<form [formGroup]="form">
  <div class="form-group row">
    <div class="col-6">
      <mat-form-field class="mat-form-field-fluid">
        <input matInput formControlName="name" placeholder="Template Name" />
        <mat-error>Template Name <strong>required</strong></mat-error>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field class="mat-form-field-fluid">
        <mat-select formControlName="client_id" placeholder="Client">
          <mat-option [value]="-1">
            None
          </mat-option>
          <mat-option *ngFor="let item of (clients$|async)" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
        <mat-error>Client is <strong>required</strong></mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-12">
      <div class="templating-field sections-container">
        <div class="buttons-container">
          <button mat-raised-button type="button" color="primary" (click)="onNewSectionClick()">New Section</button>
          <button mat-raised-button type="button" color="warn" (click)="onResetSections()">Reset</button>
        </div>
        <div class="section-wrapper">
          <div class="section">
            <mat-checkbox formControlName="cover_page_included"></mat-checkbox>
            <span>
              Cover page
            </span>
          </div>
          <div class="section-content">
            <input class="name-input" formControlName="cover_page_title" />
            <div class="section-content-toggle-field">
              <span>Show:</span>
              <mat-slide-toggle formControlName="client_id_included"></mat-slide-toggle>
              <span>Client ID</span>
            </div>
            <div class="section-content-toggle-field">
              <span>Show:</span>
              <mat-slide-toggle formControlName="assignment_id_included"></mat-slide-toggle>
              <span>Assignment ID</span>
            </div>
            <div class="section-content-toggle-field">
              <span>Show:</span>
              <mat-slide-toggle formControlName="toe_id_included"></mat-slide-toggle>
              <input class="name-input toe-label" formControlName="toe_id_label" />
            </div>
            <div class="section-content-toggle-field">
              <span>Show:</span>
              <mat-slide-toggle formControlName="date_of_instruction_included"></mat-slide-toggle>
              <span>Date of instruction</span>
            </div>
            <div class="section-content-toggle-field">
              <span>Show:</span>
              <mat-slide-toggle formControlName="footer_module_included"></mat-slide-toggle>
              <span>Footer module</span>
            </div>
          </div>
        </div>
        <div class="section-wrapper">
          <div class="section">
            <mat-checkbox formControlName="toc_included"></mat-checkbox>
            <span>
              Table of Contents
            </span>
          </div>
        </div>
        <kt-draggable [sections]="sections$|async" (sectionsChanged)="onSectionsChanged($event)">
        </kt-draggable>
        <div class="section-wrapper">
          <div class="section">
            <mat-checkbox formControlName="back_page_included"></mat-checkbox>
            <span>
              Back page
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>